
import { computed, defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

const COMPANY_CHECKUP_TYPE = 1
const PERSON_CHECKUP_TYPE = 2
const AUTO_CHECKUP_TYPE = 3

export default defineComponent({
    components: {
        Loader,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isConfirmed: {
            type: Boolean,
            default: false,
        },
        isDeclined: {
            type: Boolean,
            default: false,
        },
        isAccepted: {
            type: Boolean,
            default: null,
        },
        declineReason: {
            type: String,
            default: null,
        },
        type: {
            type: Number,
            default: COMPANY_CHECKUP_TYPE,
        },
    },
    setup(props) {
        const message = computed(() => {
            if (props.isConfirmed) {
                if (props.type === COMPANY_CHECKUP_TYPE) return 'Ранее компании было разрешено'
                if (props.type === PERSON_CHECKUP_TYPE) return 'Ранее физ. лицу было разрешено'
                if (props.type === AUTO_CHECKUP_TYPE) return 'Ранее авто было разрешено'
            }

            if (props.isDeclined && props.isAccepted === false) {
                if (props.type === COMPANY_CHECKUP_TYPE)
                    return `Ранее компании было отказано (${props.declineReason})`
                if (props.type === PERSON_CHECKUP_TYPE)
                    return `Ранее физ. лицу было отказано (${props.declineReason})`
                if (props.type === AUTO_CHECKUP_TYPE)
                    return `Ранее авто было отказано (${props.declineReason})`
            }

            return ''
        })

        return { message }
    },
})
